<template>
  <div style="z-index: 3;">
    <v-snackbar v-model="snackbar" :timeout="4000" bottom right :color="color">
      <span>{{ message }}</span>
    </v-snackbar>
    <v-app-bar style="
        background-image: linear-gradient(
          to bottom,
          rgba(255, 255, 255, 1),
          rgba(255, 255, 255, 0.5)
        );
      " color="#ffffff" elevate-on-scroll app class="m-0 p-0" height="55px">
      <div class="d-flex align-center mt-0 pt-0" :style="{ width: '100%' }" height="30px">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="hidden-md-and-up primary--text">
        </v-app-bar-nav-icon>
        <v-btn small depressed class="transparent transparent--text hidden-sm-and-down text-none"
          style="position: absolute; right: 1px" v-if="!isAuthenticated">{{ $t("loginMessage") }}
        </v-btn>
        <v-btn v-if="isAuthenticated" small depressed
          class="transparent transparent--text text-none hidden-sm-and-down">
          <v-avatar>
            <v-icon> mdi-account-circle </v-icon>
          </v-avatar>
          <div class="ml-2">
            {{ getProfile.first_name }} {{ getProfile.last_name }}
          </div>

          <v-icon small right>mdi-chevron-down</v-icon>
        </v-btn>
        <v-spacer class="d-sm-none"></v-spacer>
        <v-layout row wrap class="mr-10 mt-1 hidden-sm-and-down">
          <v-flex xs8> </v-flex>
          <v-flex xs1 align="right">
            <!-- <v-btn
              text
              class="ml-15 text-none"
              v-if="$can('workflow_actions_view')"
              to="/workflowactionlog"
          >
              {{ $t("approvalsMsg") }}
              <div v-if="workflowactionlogPagination.total != 0">
                  <v-badge
                      light
                      overlap
                      color="red"
                      :content="workflowactionlogPagination.total"
                  >
                      <v-icon dark class="secondary--text ml-3"> mdi-bell</v-icon>
                  </v-badge>
              </div>
              <div v-else>
                  <v-icon dark class="secondary--text ml-3"> mdi-bell</v-icon>
              </div>
          </v-btn> -->
          </v-flex>
          <v-flex xs3>
            <v-select style="width: 90px; margin-left: auto" :items="languages" item-value="language" item-text="title"
              v-model="languageChoice" @input="changeLocale()"></v-select>
          </v-flex>
        </v-layout>
        <v-btn small depressed class="secondary white--text hidden-sm-and-down text-none" @click="changeLoginCardState"
          v-if="!isAuthenticated">{{ $t("loginMessage") }}
          <v-icon right small>mdi-location-enter</v-icon>
        </v-btn>

        <v-menu left offset-y v-if="isAuthenticated">
          <template v-slot:activator="{ on, attrs }">
            <v-btn small v-bind="attrs" v-on="on" depressed class="secondary text-none hidden-sm-and-down">
              <v-avatar size="36" v-if="getProfile.profile_pic != null">
                <img :src="path + '/profile_pics/' + getProfile.profile_pic" alt="PPIC" />
              </v-avatar>
              <v-avatar v-else>
                <v-icon> mdi-account-circle </v-icon>
              </v-avatar>
              <div class="ml-2">
                {{ getProfile.first_name }} {{ getProfile.last_name }}
              </div>

              <v-icon small right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item router to="/profile">
              <v-list-item-title class="body-2">{{
                $t("profileMessage")
                }}</v-list-item-title>
            </v-list-item>

            <v-list-item router to="/dashboard" v-if="$can('dashboard_view')">
              <v-list-item-title class="body-2">{{
                $t("dashboardMessage")
                }}</v-list-item-title>
            </v-list-item>
            <v-list-item router to="/role" v-if="$can('role_view')">
              <v-list-item-title class="body-2">{{
                $t("rolesMessage")
                }}</v-list-item-title>
            </v-list-item>
            <v-list-item router to="/logs" v-if="$can('log_view')">
              <v-list-item-title class="body-2">{{
                $t("logsMessage")
                }}</v-list-item-title>
            </v-list-item>
            <v-list-item router to="/user" v-if="$can('user_view')">
              <v-list-item-title class="body-2">{{
                $t("usersMessage")
                }}</v-list-item-title>
            </v-list-item>
            <v-list-item router to="/item-manager" v-if="$can('manage_items_view')">
              <v-list-item-title class="body-2">{{
                $t("manageItemsMessage")
                }}</v-list-item-title>
            </v-list-item>
            <v-list-item router to="/workflow" v-if="$can('workflow_view')">
              <v-list-item-title class="body-2">{{
                $t("workflowManagementMsg")
                }}</v-list-item-title>
            </v-list-item>
            <v-list-item router to="/workflowactionlog" v-if="$can('workflow_actions_view')">
              <v-list-item-title class="body-2">{{
                $t("myWorkflowApprovalsMsg")
                }}</v-list-item-title>
            </v-list-item>
            <v-list-item router to="/admin/faq" v-if="$can('workflow_actions_view')">
              <v-list-item-title class="body-2">{{
                $t("manageFAQsMsg")
              }}</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="signOut">
              <v-list-item-title class="body-2">{{
                $t("signOutMessage")
                }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <template v-slot:extension class="d-flex justify-space-between">
        <div class="hide-sm" style="padding-bottom: 1em">
          <a @click="goToHome()">
            <v-img max-width="100" max-height="54" contain class="mt-2 mb-3 hidden-sm-and-down" src="img/aatf_logo.png">
            </v-img>
          </a>
          <a @click="goToHome()">
            <v-img max-width="100" max-height="100" class="mt-2 mb-3 hidden-md-and-up" src="img/aatf_logo.png">
            </v-img>
          </a>
        </div>
        <div class="mid-line">
          <v-btn small text class="text-none mr-1 hidden-sm-and-down primary white--text" router to="/"
            v-if="$route.name == 'Home'">
            <v-icon small left>mdi-home</v-icon>
            {{ $t("homeMessage") }}
          </v-btn>
          <v-btn small text class="text-none mr-1 hidden-sm-and-down" router to="/" v-if="$route.name != 'Home'">
            <v-icon small left>mdi-home</v-icon>
            <div>{{ $t("homeMessage") }}</div>
          </v-btn>
          <v-btn small text class="text-none mr-1 hidden-sm-and-down primary white--text" router to="/publications"
            v-if="$route.name == 'Publications'">
            <v-icon small left>mdi-note-multiple-outline</v-icon>
            {{ $t("publicationMessage") }}
          </v-btn>
          <v-btn small text class="text-none mr-1 hidden-sm-and-down" router to="/publications"
            v-if="$route.name != 'Publications'">
            <v-icon small left>mdi-note-multiple-outline</v-icon>
            {{ $t("publicationMessage") }}
          </v-btn>
          <v-btn small text class="text-none mr-1 hidden-sm-and-down primary white--text" router to="/ipbsl"
            v-if="$route.name == 'IPBiosafetyLaws'">
            <v-icon small left>mdi-gavel</v-icon>
            {{ $t("IPBioSafetyLawsMessage") }}
          </v-btn>
          <v-btn small text class="text-none mr-1 hidden-sm-and-down" router to="/ipbsl"
            v-if="$route.name != 'IPBiosafetyLaws'">
            <v-icon small left>mdi-gavel</v-icon>
            {{ $t("IPBioSafetyLawsMessage") }}
          </v-btn>

          <v-menu left offset-y open-on-hover>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small v-bind="attrs" v-on="on" text class="text-none mr-1 hidden-sm-and-down"
                :class="{ 'primary white--text': $route.name === 'Media' }" router to="/media">
                <v-icon small left>mdi-multimedia</v-icon>
                {{ $t("mediaMessage") }}
              </v-btn>
            </template>

            <v-list>
              <!-- All links match the /media route, so they all render as active links, which isn't ideal,
               so make all of them render as inactive by setting a custom active class that makes the link
               look inactive
               -->
              <v-list-item to="/media?tab=images" active-class="active-media-link">
                <v-list-item-title class="body-2"><v-icon small left>mdi-image</v-icon>{{ $t("imagesMsg")
                  }}</v-list-item-title>
              </v-list-item>
              <v-list-item router to="/media?tab=videos" active-class="active-media-link">
                <v-list-item-title class="body-2"><v-icon small left>mdi-video</v-icon>{{ $t("videosMsg")
                  }}</v-list-item-title>
              </v-list-item>
              <v-list-item router to="/media?tab=audios" active-class="active-media-link">
                <v-list-item-title class="body-2"><v-icon small left>mdi-cassette</v-icon>{{ $t("audiosMsg")
                  }}</v-list-item-title>
              </v-list-item>
              <v-list-item router to="/media" active-class="active-media-link">
                <v-list-item-title class="body-2"><v-icon small left>mdi-multimedia</v-icon>{{ $t("allMsg")
                  }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn small text class="text-none mr-1 hidden-sm-and-down primary white--text" router to="/projects"
            v-if="$route.name == 'Projects'">
            <v-icon small left>mdi-wind-power</v-icon>
            {{ $t("projectsMessage") }}
          </v-btn>
          <v-btn small text class="text-none mr-1 hidden-sm-and-down" router to="/projects"
            v-if="$route.name != 'Projects'">
            <v-icon small left>mdi-wind-power</v-icon>
            {{ $t("projectsMessage") }}
          </v-btn>
          <v-btn small text class="text-none mr-1 hidden-sm-and-down primary white--text" router to="/opportunities"
            v-if="$route.name == 'opportunities'">
            <v-icon small left>mdi-script-text</v-icon>
            {{ $t("opportunitiesMessage") }}
          </v-btn>
          <v-btn small text class="text-none mr-1 hidden-sm-and-down" router to="/opportunities"
            v-if="$route.name != 'opportunities'">
            <v-icon small left>mdi-script-text</v-icon>
            {{ $t("opportunitiesMessage") }}
          </v-btn>
          <v-btn small text class="text-none mr-1 hidden-sm-and-down primary white--text" router to="/blogs"
            v-if="$route.name == 'blogs'">
            <v-icon small left>mdi-post</v-icon>
            {{ $t("blogsMessage") }}
          </v-btn>
          <v-btn small text class="text-none mr-1 hidden-sm-and-down" router to="/blogs" v-if="$route.name != 'blogs'">
            <v-icon small left>mdi-post</v-icon>
            {{ $t("blogsMessage") }}
          </v-btn>
          <v-btn small text class="text-none mr-1 hidden-sm-and-down primary white--text" router to="/faqs"
            v-if="$route.name == 'faqs'">
            <v-icon small left>mdi-frequently-asked-questions</v-icon>
            {{ $t("faqsMessage") }}
          </v-btn>
          <v-btn small text class="text-none mr-1 hidden-sm-and-down" router to="/faqs" v-if="$route.name != 'faqs'">
            <v-icon small left>mdi-frequently-asked-questions</v-icon>
            {{ $t("faqsMessage") }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn small depressed class="secondary white--text hidden-md-and-up text-none" @click="changeLoginCardState"
            v-if="!isAuthenticated">{{ $t("loginMessage") }}
            <v-icon right small>mdi-location-enter</v-icon>
          </v-btn>
        </div>
        <div class="hide-sm"></div>
      </template>
    </v-app-bar>
    <v-navigation-drawer disable-resize-watcher app v-model="drawer">
      <v-list-group :value="false" prepend-icon="mdi-account-circle" v-if="isAuthenticated">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>{{ getProfile.first_name }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item router to="/profile">
          <v-list-item-title class="body-2">{{
            $t("profileMessage")
            }}</v-list-item-title>
        </v-list-item>

        <v-list-item router to="/dashboard" v-if="$can('dashboard_view')">
          <v-list-item-title class="body-2">{{
            $t("dashboardMessage")
            }}</v-list-item-title>
        </v-list-item>
        <v-list-item router to="/roles" v-if="$can('role_view')">
          <v-list-item-title class="body-2">{{
            $t("rolesMessage")
            }}</v-list-item-title>
        </v-list-item>
        <v-list-item router to="/logs" v-if="$can('log_view')">
          <v-list-item-title class="body-2">{{
            $t("logsMessage")
            }}</v-list-item-title>
        </v-list-item>
        <v-list-item router to="/users" v-if="$can('user_view')">
          <v-list-item-title class="body-2">{{
            $t("usersMessage")
            }}</v-list-item-title>
        </v-list-item>
        <v-list-item router to="/item-manager" v-if="$can('manage_items_view')">
          <v-list-item-title class="body-2">{{
            $t("manageItemsMessage")
            }}</v-list-item-title>
        </v-list-item>
        <v-list-item router to="/workflow" v-if="$can('workflow_view')">
          <v-list-item-title class="body-2">{{
            $t("workflowManagementMsg")
            }}</v-list-item-title>
        </v-list-item>
        <v-list-item router to="/workflowactionlog" v-if="$can('workflow_actions_view')">
          <v-list-item-title class="body-2">{{
            $t("myWorkflowApprovalsMsg")
            }}</v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
      </v-list-group>
      <v-list dense nav>
        <v-list-item class="white primary--text">
          <v-list-item-icon>
            <v-icon class="white--text">mdi-flag</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <v-select style="font-family: 'SC Prosper Sans Regular'" :items="languages" item-value="language"
              item-text="title" v-model="languageChoice" @input="changeLocale()"></v-select>
          </v-list-item-title>
        </v-list-item>

        <v-list-item router to="/" class="primary white--text" v-if="$route.name == 'Home'">
          <v-list-item-icon>
            <v-icon class="white--text">mdi-home</v-icon>
          </v-list-item-icon>

          <v-list-item-title>{{ $t("homeMessage") }}</v-list-item-title>
        </v-list-item>
        <v-list-item router to="/" class="white primary--text" v-if="$route.name != 'Home'">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>

          <v-list-item-title class="grey--text text--darken-2">{{
            $t("homeMessage")
            }}</v-list-item-title>
        </v-list-item>

        <v-list-item router to="/publications" class="primary white--text" v-if="$route.name == 'Publications'">
          <v-list-item-icon>
            <v-icon class="white--text">mdi-note-multiple-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-title>{{ $t("publicationMessage") }}</v-list-item-title>
        </v-list-item>
        <v-list-item router to="/publications" class="white primary--text" v-if="$route.name != 'Publications'">
          <v-list-item-icon>
            <v-icon>mdi-note-multiple-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-title class="grey--text text--darken-2">{{
            $t("publicationMessage")
            }}</v-list-item-title>
        </v-list-item>

        <v-list-item router to="/ipbsl" class="primary white--text" v-if="$route.name == 'IPBiosafetyLaws'">
          <v-list-item-icon>
            <v-icon class="white--text">mdi-gavel</v-icon>
          </v-list-item-icon>

          <v-list-item-title>{{
            $t("IPBioSafetyLawsMessage")
            }}</v-list-item-title>
        </v-list-item>
        <v-list-item router to="/ipbsl" class="white primary--text" v-if="$route.name != 'IPBiosafetyLaws'">
          <v-list-item-icon>
            <v-icon>mdi-gavel</v-icon>
          </v-list-item-icon>

          <v-list-item-title class="grey--text text--darken-2">{{
            $t("IPBioSafetyLawsMessage")
            }}</v-list-item-title>
        </v-list-item>

        <v-list-item router to="/media" class="primary white--text" v-if="$route.name == 'Media'">
          <v-list-item-icon>
            <v-icon class="white--text">mdi-multimedia</v-icon>
          </v-list-item-icon>

          <v-list-item-title>{{ $t("mediaMessage") }}</v-list-item-title>
        </v-list-item>
        <v-list-item router to="/media" class="white primary--text" v-if="$route.name != 'Media'">
          <v-list-item-icon>
            <v-icon>mdi-multimedia</v-icon>
          </v-list-item-icon>

          <v-list-item-title class="grey--text text--darken-2">{{
            $t("mediaMessage")
            }}</v-list-item-title>
        </v-list-item>

        <v-list-item router to="/news-feed" class="primary white--text" v-if="$route.name == 'Projects'">
          <v-list-item-icon>
            <v-icon class="white--text">mdi-wind-power</v-icon>
          </v-list-item-icon>

          <v-list-item-title>{{ $t("projectsMessage") }}</v-list-item-title>
        </v-list-item>
        <v-list-item router to="/news-feed" class="white primary--text" v-if="$route.name != 'Projects'">
          <v-list-item-icon>
            <v-icon>mdi-wind-power</v-icon>
          </v-list-item-icon>

          <v-list-item-title class="grey--text text--darken-2">{{
            $t("projectsMessage")
            }}</v-list-item-title>
        </v-list-item>

        <v-list-item router to="/opportunities" class="primary white--text" v-if="$route.name == 'Opportunites'">
          <v-list-item-icon>
            <v-icon class="white--text">mdi-script-text</v-icon>
          </v-list-item-icon>

          <v-list-item-title>{{
            $t("opportunitiesMessage")
            }}</v-list-item-title>
        </v-list-item>
        <v-list-item router to="/opportunities" class="white primary--text" v-if="$route.name != 'Opportunites'">
          <v-list-item-icon>
            <v-icon>mdi-script-text</v-icon>
          </v-list-item-icon>

          <v-list-item-title class="grey--text text--darken-2">{{
            $t("opportunitiesMessage")
            }}</v-list-item-title>
        </v-list-item>

        <v-list-item router to="/faqs" class="primary white--text" v-if="$route.name == 'FAQs'">
          <v-list-item-icon>
            <v-icon class="white--text">mdi-frequently-asked-questions</v-icon>
          </v-list-item-icon>

          <v-list-item-title>{{ $t("faqsMessage") }}</v-list-item-title>
        </v-list-item>
        <v-list-item router to="/faqs" class="white primary--text" v-if="$route.name != 'FAQs'">
          <v-list-item-icon>
            <v-icon>mdi-frequently-asked-questions</v-icon>
          </v-list-item-icon>

          <v-list-item-title class="grey--text text--darken-2">{{
            $t("faqsMessage")
            }}</v-list-item-title>
        </v-list-item>

        <v-list-item @click="signOut" class="red lighten-4" v-if="isAuthenticated">
          <v-list-item-icon>
            <v-icon>mdi-lock</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="body-2">{{
            $t("signOutMessage")
            }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<style scoped>
.active-media-link::before {
  opacity: 0;
}
</style>

<script>
import apiCall from "@/utils/api";
import Vue from "vue";
import { AUTH_LOGOUT } from "@/store/actions/auth";
import { USER_REQUEST } from "@/store/actions/user";
import { mapGetters, mapActions } from "vuex";
import i18n from "@/plugins/i18n";

export default {
  components: {},
  data() {
    return {
      path: process.env.VUE_APP_API_URL,
      color: "",
      message: "",
      snackbar: false,
      drawer: false,
      languageChoice: "",
      languages: [
        { flag: "en", language: "en", title: "English" },
        { flag: "fr", language: "fr", title: "Français" },
        { flag: "ke", language: "sw", title: "Swahili" },
        { flag: "de", language: "de", title: "German" },
      ],
    };
  },
  watch: {
    darkState() {
      this.handledarkmode();
    },
  },
  created() {
    this.initialize();
  },
  mounted() {
    if (this.isAuthenticated) {
      this.$store.dispatch(USER_REQUEST);
    }
  },
  methods: {
    ...mapActions([
      "changeDarkState",
      "changeLoginCardState",
      "changeLanguage",
    ]),

    initialize() {
      this.languageChoice = this.language;
    },

    signOut: function () {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push("/"));
    },
    goToHome() {
      this.$router.push("/");
    },
    handledarkmode() {
      if (this.darkState == true) {
        this.$vuetify.theme.dark = true;
      } else {
        this.$vuetify.theme.dark = false;
      }
    },

    changeLocale() {
      i18n.locale = this.languageChoice;
      this.changeLanguage(this.languageChoice);
    },
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "darkState",
      "isAuthenticated",
      "headerColor",
      "notifications",
      "unreadMessages",
      "language",
      "workflowactionlogPagination",
    ]),
  },
};
</script>
<style scoped>
* {
  font-family: "SC Prosper Sans Regular";
  font-size: 0.75rem !important;
}

@media (max-width: 500px) {
  .hide-sm {
    display: none;
  }
}

@media (min-width: 800px) {
  .mid-line {
    margin: auto;
  }
}
</style>
